import React from 'react';
import ContentOne from './ContentOne';
import ContentThree from './ContentThree';
import ContentTwo from './ContentTwo';
import HomeImage from './HomeImage';

function Home({ element }) {
  return (
    <div ref={element}>
      <div className="container">
        <HomeImage />
        <ContentOne />
      </div>
      <div className="prof-wrap">
        <ContentTwo />
      </div>
      <div className="resume">
        <ContentThree />
      </div>
    </div>
  );
}

export default Home;
